import { defineStore } from 'pinia'

export type SnackbarPayload = {
  text: string

  /**
   * Default: 8000
   */
  timeout?: number

  /**
   * Default: "notification"
   */
  color?: 'success' | 'error' | 'notification'

  /**
   * Default: `$i18n.t('close')`
   */
  closeText?: string
}

export const useSnackbarStore = defineStore('snackbar', () => {
  const i18n = useNuxtApp().$i18n as unknown as ReturnType<typeof useI18n>

  const isVisible = ref(false)
  const timeout = ref(8000)
  const text = ref('info')
  const color = ref('notification')
  const closeText = ref(i18n.t('close'))

  const showMessage = (payload: SnackbarPayload) => {
    timeout.value = payload.timeout ?? 8000
    text.value = payload.text
    color.value = payload.color ?? 'notification'
    isVisible.value = true
    closeText.value = payload.closeText ?? i18n.t('close')
  }

  return {
    isVisible,
    timeout,
    text,
    color,
    closeText,
    showMessage,
  }
})
